/** This file is auto-generated by Plasmic; please do not edit! */

import * as React from 'react';
import PlasmicLoader from '@plasmicapp/loader';

export default function PageComponent() {
    return <PlasmicLoader projectId="vQ4XUiaXZJugVeQd5GtRbX" component="Homepage"  />
}